export function pluck(array: Array<any>, key: string): Array<any> {
  return array.map((o) => o[key]);
}
